import React, { useCallback } from 'react';
import { Page, pdfjs } from 'react-pdf';
import PropTypes from 'prop-types';

import { useAsyncState } from 'utils/useAsyncState';
import Spinner from 'components/FullScreenSpinner';

import { StyledDocument } from './styles';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const Pdf = ({ url }) => {
  const [width, setWidth] = useAsyncState();
  const onLoadSuccess = useCallback(
    ({ originalHeight, originalWidth, rotate }) => {
      if (rotate === 90 || rotate === 270) {
        setWidth((originalHeight / originalWidth) * 140);
      } else {
        setWidth((originalWidth / originalHeight) * 140);
      }
    },
    [setWidth]
  );

  if (!url) return null;

  return (
    <StyledDocument
      file={url}
      $width={width}
      loading={<Spinner size={40} height="140px" />}
      noData="Keine PDF-Datei angegeben."
      error="PDF-Datei konnte nicht geladen werden."
    >
      <Page
        pageNumber={1}
        renderTextLayer={false}
        renderAnnotationLayer={false}
        height={140}
        width={width}
        onLoadSuccess={onLoadSuccess}
      />
    </StyledDocument>
  );
};

Pdf.defaultProps = { url: '' };
Pdf.propTypes = { url: PropTypes.string };

export default Pdf;
